import axios from '../api/index.js';

//查询弹窗表
export let getPopupQuery = () => {
    return axios.post(`/client/windows/list`);
};



// WEBPACK FOOTER //
// ./src/api/popup.js